/**
 * THE GUIDES REGISTRY. One entry per guide; a guide's content is loaded only when
 * it is opened or searched. `load: null, route` is a guide that has its own page
 * ("How to use Track", views/guide.js) until it is ported to a guide.json.
 * Adding a guide: docs/regs-reference/GUIDE-SCHEMA.md and Help › Guides.
 */
export const GUIDES = [
  {
    id: 'how-to-use-track',
    title: 'How to use Track',
    line: 'What arrives, what it becomes, who decides and where the money goes.',
    kind: 'training',
    for: 'Everyone',
    minutes: 12,
    asOf: '2026-11-03',
    load: null,
    route: 'guide',
  },
  {
    id: 'building-regulations',
    title: 'Building Regulations',
    line: 'Every Part A–T, the thresholds, who owns what at ASP, dated changes to 2029.',
    kind: 'reference',
    for: 'Engineers',
    minutes: 15,
    asOf: '2026-11-03',
    sections: 9,
    load: () => import('./building-regulations.js'),
  },
];

/** Every guide that has content, loaded. */
export async function loadGuides() {
  const mods = await Promise.all(GUIDES.filter((g) => g.load).map((g) => g.load()));
  return mods.map((m) => m.GUIDE);
}
